import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/lib/auth-context'

export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (user) {
    return <Navigate to="/dashboard" />
  }

  return <Navigate to="/login" />
}
